<script>
  import { Icon } from '@shopboxai/sb-portal-components';
  import GridCodeDialog from './dialogs/list/GridCodeDialog.svelte';
  import CreateByLayoutOne from './dialogs/list/CreateByLayoutOne.svelte';
  import CreateByLayoutTwo from './dialogs/list/CreateByLayoutTwo.svelte';
  import CreateByLayoutThree from './dialogs/list/CreateByLayoutThree.svelte';
  import CreateByLayoutFour from './dialogs/list/CreateByLayoutFour.svelte';
  import CreateFromScratch from './dialogs/list/CreateFromScratch.svelte';
  import GridArchiveDialog from './dialogs/list/GridArchiveDialog.svelte';
  import { listGrid, postGrid, deleteGrid, checkGridState } from '../api';
  import { copyToClipboard } from '../utils';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  let runGridList = listGrid();

  const editItem = (id) => {
    dispatch('editItem', { id: id });
  };
  const submitArchive = async (payload) => {
    await deleteGrid({ id: payload.detail.id });
    runGridList = listGrid();
  };
  const submitCopy = async (payload) => {
    copyToClipboard(payload.detail);
  };
  const isGridActive = async (gridId) => {
    try {
      let state = await checkGridState(gridId);

      return state ? 'Active' : 'Inactive';
    } catch (error) {
      return 'Inactive';
    }
  };
  const submitCreate = async (payload) => {
    await postGrid(payload.detail);
    runGridList = listGrid();
  };
</script>

<header>
  <h1>Shopbox grid builder</h1>

  <CreateFromScratch on:submit={submitCreate} />
</header>
<div class="predefined">
  <h2>Explore our grids</h2>
  <CreateByLayoutOne on:submit={submitCreate} />
  <CreateByLayoutTwo on:submit={submitCreate} />
  <CreateByLayoutThree on:submit={submitCreate} />
  <CreateByLayoutFour on:submit={submitCreate} />
</div>
<table class="grid-table">
  <thead style="border-bottom: 1px solid #000">
    <tr>
      <h3>Your grids</h3>
      <th />
    </tr>
    <tr>
      <th>Grid name</th>
      <th align="left">Last Modified</th>
      <th align="left">Status</th>
      <th align="left">Actions</th>
    </tr>
  </thead>
  <tbody>
    {#await runGridList then grids}
      {#if Array.isArray(grids)}
        {#each grids as grid}
          {#if grid.name}
            <tr>
              <td>
                <p style="font-size:0.7rem;opacity:0.6">{grid.id}</p>
                <p>{grid.name}</p>
              </td>
              <td>
                <p>{new Date(grid.updated_at).toLocaleString()}</p>
              </td>
              <td>
                <p class="status">
                  {#await isGridActive(grid.id)}
                    Loading..
                  {:then value}
                    <span class="indicator" class:active={value == 'Active'} />{value}
                  {/await}
                </p>
              </td>
              <td width="150px">
                <button on:click={() => editItem(grid.id)}><Icon name="settings" /></button>
                <GridCodeDialog on:submit={submitCopy} data={grid.id} on:submit={submitCopy} />
                <GridArchiveDialog data={{ id: grid.id }} on:submit={submitArchive} />
              </td>
            </tr>
          {/if}
        {:else}
          <tr>No grids found for this client</tr>
        {/each}
      {:else}
        <tr>No grids found for this client</tr>
      {/if}
    {/await}
  </tbody>
</table>

<style>h1{font-family:Chivo,sans-serif;font-weight:900}h2{font-size:24px;font-weight:400;letter-spacing:1.5px;line-height:30px}h2,h3{color:#43414b;font-family:Overpass}h3{font-size:18px;font-style:normal;font-weight:700;letter-spacing:.15px;line-height:23px}header{align-items:center;display:flex;justify-content:space-between;padding:1em 0}.grid-table{border:1px solid #d0d0d2;border-collapse:separate;border-radius:2px;border-spacing:0 5px;font-size:1.1rem;margin-bottom:2em;padding:24px 12px 8px;width:100%}.grid-table thead th{color:#727178;font-weight:300;letter-spacing:.4px}.grid-table thead tr:last-of-type th{border-bottom:1px solid #d0d0d2;padding:.4em 0}.grid-table td:first-of-type,.grid-table th:first-of-type{text-align:left}.grid-table tbody tr td{box-shadow:inset 0 -1px 0 rgba(0,0,0,.1);padding:.5em .1em}.grid-table p{color:#43414b;font-family:Overpass;font-size:16px;font-style:normal;font-weight:400;letter-spacing:.4px;line-height:18px}.predefined{display:grid;gap:1em;grid-template-columns:1fr 1fr 1fr 1fr;margin-bottom:2em;margin-top:1em}.predefined h2{grid-column:span 4}.predefined :global(.create-button){align-items:center;background:#fff;border-radius:4px;box-shadow:0 0 8px -2px rgba(24,39,75,.12),0 4px 4px -2px rgba(24,39,75,.16);display:grid;grid-column:span 1;grid-template-columns:-webkit-min-content 2fr;grid-template-columns:min-content 2fr;min-height:80px;padding:1em;place-content:center;width:100%}.predefined :global(.create-button div){color:#43414b;height:100%;padding:.2em 1em;text-align:left;width:100%}.status{align-items:center;display:flex}.indicator{border:1px solid #000;border-radius:50%;content:"";display:inline-block;height:7px;margin-bottom:2px;margin-right:4px;transform:scale(1.1);width:7px}.indicator.active{background-color:#2dc307;border:1px solid #2dc307}</style>
